import spriteHref from "./spriteHref";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/shift-away.css";

export default function initShowTooltip() {
  if (document.readyState !== "loading") {
    showTooltip();
  } else {
    document.addEventListener("DOMContentLoaded", showTooltip);
  }
}

function showTooltip() {
  const tooltipContainers = document.querySelectorAll(".js-tooltip-container");

  if (!tooltipContainers.length) return;

  tooltipContainers.forEach((tooltipContainer) => {
    const tooltipTrigger = tooltipContainer.querySelector(".js-tooltip-trigger");

    if (!tooltipTrigger) return;

    const tooltipPlacement = tooltipContainer.dataset.placement;
    const tooltipContent = tooltipContainer.dataset.content;
    const tooltipTriggerType = tooltipContainer.dataset.triggerType;
    const tooltipInteractive = tooltipContainer.dataset.interactive;
    const tooltipOffsetData = tooltipContainer.dataset.offset;
    const tooltipOffset = tooltipOffsetData
      ? tooltipOffsetData.split(",").map((num) => Number(num.trim()))
      : [0, 10];
    const tooltipZIndex = tooltipContainer.dataset.zIndex;

    const tooltipCloseButton = tooltipContainer.dataset.closeButton || "true";

    tippy(tooltipTrigger, {
      content: tooltipContent || "",
      interactive: tooltipInteractive || true,
      trigger: tooltipTriggerType || "mouseenter focus",
      allowHTML: true,
      placement: tooltipPlacement || "top",
      arrow: true,
      animation: "shift-away",
      offset: tooltipOffset,
      zIndex: tooltipZIndex || 9999,
      onShow(instance) {
        if (tooltipCloseButton === "false") return;

        const tippyBox = instance.popper.querySelector(".tippy-box");

        let closeButton = tippyBox.querySelector(".tooltip-close");
        if (!closeButton) {
          closeButton = document.createElement("button");
          closeButton.classList.add("tooltip-close");
          closeButton.innerHTML = `
              <svg class="tooltip-close-icon">
                <use href="${spriteHref("sprite-icon-cross")}"></use>
              </svg>`;
          tippyBox.appendChild(closeButton);
        }

        if (closeButton._tippyCloseHandler) {
          closeButton.removeEventListener(
            "click",
            closeButton._tippyCloseHandler
          );
        }

        closeButton._tippyCloseHandler = () => instance.hide();
        closeButton.addEventListener("click", () => instance.hide());
      },
      appendTo(reference) {
        return tooltipContainer || reference.parentElement || document.body;
      },
    });
  });
}
